import axios from 'axios';
import { ensureAccessToken } from '@/services/auth.service';
import { HubSessionService } from '@/services/hub-session.service';

const X_CUSTOMER_ID = '6d6bbb29-331b-45cb-b8f7-93a39d45429b';
const X_INSTANCE_ID = '6d6bbb29-331b-45cb-b8f7-93a39d45429b';
const X_USER_LOGIN = HubSessionService.getSession()?.email;

export default class HttpController {
  axiosInstance = undefined;

  constructor() {
    if (!HttpController._instance) {
      HttpController._instance = this;
      this.setup();
    }
    return HttpController._instance.axiosInstance;
  }

  static getInstance() {
    return this._instance.axiosInstance;
  }

  static setAuthorizationToken(token) {
    this._instance.axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
  }

  static setBaseURL(baseURL) {
    if (this._instance && this._instance.axiosInstance) {
      this._instance.axiosInstance.defaults.baseURL = baseURL;
    }
  }

  static getBaseURL() {
    if (this._instance && this._instance.axiosInstance) {
      return this._instance.axiosInstance.defaults.baseURL;
    }
    return null;
  }

  setup() {
    this.axiosInstance = axios.create({
      baseURL: '/va-insight',
      headers: {
        'Content-Type': 'application/json',
        'X-Customer-ID': X_CUSTOMER_ID,
        'X-Instance-ID': X_INSTANCE_ID,
        'X-User-Login': X_USER_LOGIN,
        Authorization: `Bearer ${localStorage.getItem('accessToken') || ''}`,
      },
      timeout: 300 * 1000,
      responseEncoding: 'iso-8859-1',
      transformRequest: [
        (data) => {
          return JSON.stringify(data);
        },
      ],
    });

    this.axiosInstance.interceptors.request.use(
      async (config) => {
        const token = await ensureAccessToken();
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${token}`;

        // garante os headers de contexto sempre
        config.headers['X-Customer-ID'] = X_CUSTOMER_ID;
        config.headers['X-Instance-ID'] = X_INSTANCE_ID;

        return config;
      },
      (error) => Promise.reject(error)
    );

    this.axiosInstance.interceptors.response.use(
      (res) => res,
      (error) => {
        console.error('API Error:', error);
        return Promise.reject(error);
      }
    );
  }
}
